import { Directive, HostListener, inject, Input } from '@angular/core';
import { HisNavigationService } from '../service/base/his-navigation.service';

@Directive({
    selector: 'input, textarea, button, '
        + 'p-autoComplete, p-calendar, p-checkbox, p-autocomplete[multiple], p-editor, p-inputNumber, p-multiSelect, p-radioButton, '
        + 'his-multiselect, his-search-select-popup, his-tree-select-popup',
    standalone: false
})
export class HisModificationDetectionDirective {
    hisNavigationService = inject(HisNavigationService);

    /**
     * disables modification detection for the host element.
     */
    @Input() hisDisableModificationDetection = false;

    private static readonly KNOWN_HIS_IMAGES = ['ARROW_DOWN', 'ARROW_UP', 'DELETE'];

    @HostListener( 'input' )

    // Prime-NG uses onInput and onDropdownClick
    @HostListener('onInput')
    @HostListener('onDropdownClick')

    // for autocomplete in multi select mode
    @HostListener('onUnselect')

    @HostListener('click')
    @HostListener('keyup')

    // for his-tree-select-popup
    @HostListener('selectedDataChange')

    // for his-multiselect, his-search-select-popup
    @HostListener('selectedOptionsChange')

    public changed() {
        if ( this.hisDisableModificationDetection ) {
            return;
        }
        this.hisNavigationService.dirty = true;
    }

    @HostListener('click', ['$event'])
    public clicked(event: Event) {
        if ( this.hisDisableModificationDetection ) {
            return;
        }
        let target = event.target as HTMLElement;

        if ( target.classList?.contains( 'p-autocomplete-token-icon' ) ) {
            this.hisNavigationService.dirty = true;
            return;
        }

        // click target is a svg graphic element, so we need to look at
        // the parent button element instead.
        let button = target.closest( 'button' );
        if ( button ) {
            let attribute = button.getAttribute( 'hisimage' );
            if ( HisModificationDetectionDirective.KNOWN_HIS_IMAGES.indexOf( attribute ) > -1 ) {
                this.hisNavigationService.dirty = true;
            }
        }
    }

    @HostListener('window:beforeunload')
    onBeforeUnload() {
        return !this.hisNavigationService.hasUnsavedChanges;
    }

}
